import { Hierarchy } from '~/types';

export type FlatHierarchy = {
  jurisdiction: string;
  jurisdictionName: string;
  fundId: string;
  fundName: string;
  size: number;
  currency: string;
  inceptionDate: string;
  terminationDate: string;
};
/** Flatten Hierarchy Array includes jurisdiction and funds
 * */
export function flattenHierarchyArray(
  hierarchyResponses: Hierarchy[],
): FlatHierarchy[] {
  return hierarchyResponses.flatMap((hierarchyResponse) => {
    const { legalJurisdiction, funds } = hierarchyResponse;

    return funds.map((fund) => ({
      jurisdiction: legalJurisdiction.jurisdiction,
      jurisdictionName: legalJurisdiction.name,
      fundId: fund.fundId,
      fundName: fund.name,
      size: fund.size,
      currency: fund.currency,
      inceptionDate: fund.inceptionDate,
      terminationDate: fund.terminationDate,
    }));
  });
}
